import React, { Fragment } from "react";
import Divider from "@material-ui/core/Divider";
import { CircularProgress } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import _ from "lodash";
import DefaultPicture from "../../assets/images/default-picture.png";


class SearchPractitioner extends React.PureComponent {
  constructor(props){
    super(props);
    this.state = {
      apiCall: null,
      timeout: 0,
      searchText: false,
      doctorListOpen: false,  
      listOfDocNNurse: []  ,     
      filteredList: [],
    }
  };

   /* 
    Track user typing
  */

 searchDoctorList = event => {
  var searchText = event.target.value; // this is the search text
  if (this.state.timeout) clearTimeout(this.state.timeout);
  this.state.timeout = setTimeout(() => {
    if (searchText.trim().length && searchText.trim().length > 1) {
      this.setState({ doctorListOpen: true });
      // this.getDoctorList(searchText);
      this.getDoctorInfo(searchText);
    } else {
      this.setState({
        searchText: false,
        filteredList: [],
        doctorListOpen: false
      });
    }
  }, 200);
};

componentWillReceiveProps(props){  
  if(!this.state.listOfDocNNurse.length)
  this.setState({
    listOfDocNNurse: props.docList
  });
};

getDoctorInfo = (text) => {    
  let data = _.filter(this.state.listOfDocNNurse, o => {
    if (text.split(" ").length === 1) {
      let regex = new RegExp(text, "ig"),
        firstName = o.firstName.search(regex),
        lastName = o.lastName.search(regex),
        id = o.doctorId ? o.doctorId.search(regex) : -1,
        id2 = o.nurseId ? o.nurseId.search(regex) : -1;
      // let check1 = o.firstName.search(regex);
      if (firstName > -1 || lastName > -1 || id > -1 || id2 > -1) {
        return o;
      } else {
        return false;
      }
    } else if (text.split(" ").length > 1) {
      let regex = new RegExp(text, "ig"),        
        name = o.firstName + ' ' + o.lastName,
        search = name.search(regex);        
      // let check1 = o.firstName.search(regex);
      if (search > -1) {
        return o;
      } else {
        return false;
      }
    }
  });  
  this.setState({
    filteredList: data
  });
};

openChat = (values) => {  
  this.setState({ doctorListOpen: false });
  document.querySelector("#searchTextChat").value = "";
  this.props.handleOpen(values);
}



  render() {
    return (
      <div className="input-group search-pract-container">
        <input
          type="text"
          id="searchTextChat"
          className="form-control"
          placeholder="Search Practitioners"
          onKeyUp={this.searchDoctorList}
        />
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="fas fa-search"></i>
          </span>
        </div>

        {this.state.doctorListOpen === true && (
              <Fragment>
                {/* Doctor and Nurse Search record show */}
                <div
                  className={
                    this.state.filteredList.length
                      ? "search-doctor-list"
                      : "d-none"
                  }
                >
                  {this.state.filteredList &&
                    this.state.filteredList.map((values, index) => {
                      return (
                        <List
                          component="nav"
                          className="p-0"
                          key={index}
                          aria-label="secondary mailbox folders"
                        >
                          <ListItem className="p-3" button onClick={() => this.openChat( values)}>
                            <div className="row p-0 m-0">
                              <div className="col-sm-4 float-left">
                                  <img src={values.profilePic && values.profilePic.original ? values.profilePic.original : DefaultPicture} className="search-user-img" alt="instantconsult-doc" />
                              </div>
                              <div className="pl-2 col-sm-8 doctor-search-name">
                                <span>{values.firstName + ' ' + values.lastName + ' (' + (values.doctorId ? 'Doctor' : 'Nurse') + ')' }</span>
                              </div>
                            </div>
                          </ListItem>

                          <Divider />
                        </List>
                      );
                    })}
                </div>
              </Fragment>
            )}
      </div>
    );
  }
}

export default SearchPractitioner;
